import {normalizarPoliticaRol} from '../utils/permisosRol';
import { leerUsuario } from '../utils/legacyData';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc } from 'firebase/firestore';
import { onSnapshot } from '../utils/firestoreRead';
import { auth, db } from '../firebase/firebaseConfig';
import { limpiarCacheAutorizacion, usuarioDePerfil } from '../utils/authProfile';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [politicas,setPoliticas]=useState(null),[permissionsVerified,setPermissionsVerified]=useState(false);
  const [session, setSession] = useState({ user: null, profile: null, loading: true, profileVerified: false });
  const sessionUid=session.user?.uid;

  useEffect(() => {
    let stopProfile = () => {};
    let generation = 0;
    limpiarCacheAutorizacion();

    const stopAuth = onAuthStateChanged(auth, (user) => {
      stopProfile();
      const currentGeneration = ++generation;
      limpiarCacheAutorizacion();
      setSession({ user, profile: null, loading: !!user, profileVerified: false });
      if (!user) return;

      const deny = (error) => {
        if (currentGeneration !== generation) return;
        console.error('AuthContext: no se pudo verificar el perfil:', error);
        limpiarCacheAutorizacion();
        setSession({ user, profile: null, loading: false, profileVerified: false });
      };

      try {
        stopProfile = onSnapshot(doc(db, 'usuarios', user.uid), { includeMetadataChanges: true }, (snap) => {
          if (currentGeneration !== generation) return;
          // Un snapshot local o pendiente no constituye autorización verificada.
          const verified = !snap.metadata.fromCache && !snap.metadata.hasPendingWrites;
          const profile = verified && snap.exists() ? leerUsuario(snap.data(), user.uid) : null;
          limpiarCacheAutorizacion();
          const usuario = verified ? usuarioDePerfil(user, profile) : null;
          if (usuario) {
            try { localStorage.setItem('usuario', JSON.stringify(usuario)); } catch {}
          }
          setSession({ user, profile, loading: false, profileVerified: verified });
        }, deny);
      } catch (error) {
        deny(error);
      }
    });

    return () => {
      generation++;
      stopProfile();
      stopAuth();
    };
  }, []);

  useEffect(()=>{
    setPoliticas(null);setPermissionsVerified(false);
    if(!sessionUid||!session.profileVerified)return;
    return onSnapshot(doc(db,'configuracion','roles'),{includeMetadataChanges:true},snap=>{
      if(snap.metadata.fromCache||snap.metadata.hasPendingWrites)return;
      setPoliticas(snap.exists()?snap.data().roles||{}:{});setPermissionsVerified(true);
    },()=>{setPoliticas(null);setPermissionsVerified(false);});
  },[sessionUid,session.profileVerified]);
  const value = useMemo(() => ({
    ...session,permissionsVerified,
    profile:session.profile?{...session.profile,politicaRol:politicas?.[session.profile.rol]?normalizarPoliticaRol(session.profile.rol,politicas[session.profile.rol]):null}:null,
    usuario: session.profileVerified ? usuarioDePerfil(session.user, session.profile) : null,
    userData: session.profile,
  }), [session,politicas,permissionsVerified]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
